import {Component, Input, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {take} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";
import {Exam} from "../../../shared/models/exam";
import {ExamService} from "../../../shared/services/exam/exam.service";

// Candidate-facing edit of a voucher's professional situation. Reused with two
// triggers: the "Modifier" button on a voucher (free edit), and the mandatory
// step that gates the attendance confirmation (the parent chains to the
// presence modal once this one validates).
@Component({
    selector: "app-student-voucher-professional-modal",
    templateUrl: "./student-voucher-professional-modal.component.html",
    styleUrls: ["./student-voucher-professional-modal.component.scss"]
})
export class StudentVoucherProfessionalModalComponent implements OnInit {

    @Input() exam: Exam;

    // Professional situation to pre-fill: this voucher's values if any, else the
    // candidate's most recent filled voucher (computed by the parent).
    @Input() prefill: {
        qualification_level: string,
        profession: string,
        objective: string
    } = {qualification_level: "", profession: "", objective: ""};

    // Optional message shown at the top (e.g. the verification wording when this
    // modal gates the attendance confirmation).
    @Input() intro: string = "";

    professionalForm: FormGroup;
    submitting: boolean = false;

    constructor (
        public activeModal: NgbActiveModal,
        private examService: ExamService,
        private toastr: ToastrService
    ) {
        this.professionalForm = new FormGroup({
            "file_number": new FormControl(""),
            "qualification_level": new FormControl("", Validators.required),
            "profession": new FormControl("", Validators.required),
            "objective": new FormControl("", Validators.required),
        });
    }

    ngOnInit () {
        this.professionalForm.patchValue({
            "file_number": this.exam.file_number || "",
            "qualification_level": this.prefill.qualification_level || "",
            "profession": this.prefill.profession || "",
            "objective": this.prefill.objective || "",
        });
    }

    validate () {
        this.submitting = true;

        this.examService.updateProfessionalSituation(
            this.exam.id,
            this.professionalForm.value
        ).pipe(take(1)).
            subscribe(
                (res: Exam) => {
                    this.submitting = false;
                    this.activeModal.close(res);
                },
                (err) => {
                    this.toastr.error("Une erreur est survenue", "Erreur");
                    this.submitting = false;
                    throw err;
                }
            );
    }
}
